// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"d95bebab","173":"aba3be37","453":"03346f77"}[chunkId] + ".chunk.js";
};